import React from "react";

export default function ProgressTableCell({id, className, children, childSwitch}) {
    const raw = React.Children.toArray(children)
        .filter((c) => typeof c === "string" || typeof c === "number")
        .map(String)
        .join("")
        .trim();

    const percent = Math.max(0, Math.min(100, parseInt(raw, 10) || 0));

    return (
        <td key={id} className={`border px-4 py-2${className ? " " + className : ""}`} style={{minWidth: 120}}>
            {childSwitch}
            <div className="progress" style={{height: "16px"}}>
                <div
                    className="progress-bar"
                    role="progressbar"
                    style={{width: `${percent}%`}}
                    aria-valuenow={percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                >
                    {percent}%
                </div>
            </div>
        </td>
    );
}
